/**
 * product-footer-cta.js
 * Tracking des CTA du footer sticky produit mobile (.footer-price--default).
 * - Appeler  → `contact_header_interaction` (même event que le tél du header,
 *   source distincte) pour que l'appel soit catégorisé « appel » et non « CTA générique ».
 * - Réserver → `menu_interaction` (event header partagé, cf. back-to-results.js).
 * - Acheter  → `menu_interaction` + son event ecommerce add_to_cart natif.
 */
(function () {
  'use strict';

  function pushEvent(name, data) {
    if (typeof window.trackEvent === 'function') {
      window.trackEvent(name, data);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
    }
  }

  function trackMenu(label) {
    pushEvent('menu_interaction', {
      menu_location: 'product_sticky_footer',
      menu_parent: '',
      section_name: '',
      menu_label: label,
    });
  }

  var footer = document.querySelector('.footer-price--default');
  if (!footer) return;

  footer.addEventListener('click', function (e) {
    if (e.target.closest('[data-footer-call]')) {
      pushEvent('contact_header_interaction', {
        interaction_label: 'phone_call',
        source: 'product_footer',
      });
      // Identification uniforme (icône tél. → cta_name explicite, comme le tél du header).
      pushEvent('click_cta', {
        cta_name: 'phone_product_footer',
        cta_location: 'product_sticky_footer',
      });
    } else if (e.target.closest('.reserve-btn')) {
      trackMenu('Réserver');
      pushEvent('click_cta', { cta_name: 'footer_reserve', cta_location: 'product_sticky_footer' });
    } else if (e.target.closest('.add-to-cart')) {
      trackMenu('Acheter');
      pushEvent('click_cta', { cta_name: 'footer_add_to_cart', cta_location: 'product_sticky_footer' });
    }
  });
})();
